import { buildSubgrid } from "./helpers";

const IconSubgridWithAds = ({
    numberOfRowsBetweenAds,
    iconData,
    numberOfColumns,
    gridSpacingSize
}) => {
    if (!iconData || !iconData.length) return null;

    return buildSubgrid({
        numberOfColumns,
        numberOfRowsBetweenAds,
        gridSpacingSize,
        iconData
    });
};

export default IconSubgridWithAds;
